import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { DropdownItem } from 'reactstrap';
import { Dispatch } from 'redux';
import { hasPrivilege } from '../../../stores/auth/selectors';
import { RootState } from '../../../stores/store';
import { selected } from '../../../stores/tables/selectors';
import { deactivateUsers } from '../../../stores/users/actionCreators';
import ConfirmModal from '../../common/modals/ConfirmModal';

interface Props extends LocalizeContextProps {
    hasPrivilege: (privileges: string[]) => boolean;
    selected: string[];

    deactivateUsers: (ids: string[]) => void;
}
interface State {
    showModal: boolean;
}

class DeactivateUsersAction extends React.Component<Props, State> {
    public constructor(props: Props) {
        super(props);
        this.state = {
            showModal: false,
        };
    }

    public render() {
        const t = this.props.translate;
        if (this.props.hasPrivilege(['ACTIVATE_USER', 'USER_ADMIN', 'SUPER_ADMIN'])) {
            return (
                <React.Fragment>
                    <DropdownItem
                        onClick={() => {
                            this.setState({ showModal: true });
                        }}
                    >
                        <FontAwesomeIcon icon={['fal', 'toggle-off']} />
                        {t('users.button.deactivate')}
                    </DropdownItem>
                    <ConfirmModal
                        header={t('users.modal.deactivate.header') as string}
                        confirmText={t('users.modal.deactivate.deactivate') as string}
                        buttonColor="danger"
                        isOpen={this.state.showModal}
                        confirm={() => {
                            this.props.deactivateUsers(this.props.selected);
                        }}
                        cancel={() => { this.setState({ showModal: false }); }}
                    >
                        {t('users.modal.deactivate.text') as string}
                    </ConfirmModal>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }
}

const mapStateToProps = (state: RootState) => ({
    hasPrivilege: hasPrivilege(state),
    selected: selected(state, 'users'),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    deactivateUsers: (ids: string[]) => dispatch(deactivateUsers(ids)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(DeactivateUsersAction));